import { BadgeSharedProps } from "@certn/cascadia";
import { css } from "@emotion/css";

import { Text } from "../../foundations/typography/Text";
import { useColors } from "../../hooks/useColors";

interface Props extends BadgeSharedProps {}

export function _Badge(props: Props) {
  const { color, fill, children, testID = "badge", size = "large" } = props;
  const colors = useColors();

  return (
    <div
      className={css(size === "large" ? styles.large : styles.small, {
        color: color ? colors[color] : undefined,
        background: fill ? colors[fill] : undefined,
      })}
      data-testid={testID}
    >
      {size === "large" && (
        <Text
          style="global/label-small"
          color={color}
          className={css({ textAlign: "center" })}
        >
          {children}
        </Text>
      )}
    </div>
  );
}

const styles = {
  large: css({
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    height: "fit-content",
    width: "fit-content",
    borderRadius: "var(--border-radius-half)",
    paddingTop: "var(--space-0)",
    paddingLeft: "var(--space-1)",
    paddingBottom: "var(--space-0)",
    paddingRight: "var(--space-1)",
    gap: "var(--space-1)",
  }),
  small: css({
    display: "flex",
    alignItems: "center",
    width: "6px",
    height: "6px",
    borderRadius: "var(--border-radius-half)",
    paddingTop: "var(--space-0)",
    paddingLeft: "var(--space-0)",
    paddingBottom: "var(--space-0)",
    paddingRight: "var(--space-0)",
    flexShrink: 0,
    gap: "var(--space-1)",
  }),
};
